import { useEffect } from 'react';
import type { PropsWithChildren } from 'react';
import { useController } from 'react-hook-form';
import type { FieldValues } from 'react-hook-form';

import { useOtherDocumentsUploadProps } from '@xing-com/crate-jobs-domain-apply-uploads';

import { DocumentsUpload } from './documents-upload';
import type { UploadFieldProps } from './types';

export const OtherDocumentsUploadField = <T extends FieldValues>({
  control,
  path,
  updateValue,
  trackNwtEvent,
}: PropsWithChildren<UploadFieldProps<T>>): React.ReactElement => {
  const { uploads, ...docUploadProps } = useOtherDocumentsUploadProps();

  const {
    field: { ref: otherDocsFieldRef },
  } = useController({
    name: path,
    control,
  });

  useEffect(() => {
    const updatedUploads = uploads
      .map(({ id }) => id)
      .filter(Boolean)
      .join(',');

    updateValue(updatedUploads, path);
  }, [uploads, updateValue, path]);

  return (
    <section>
      <DocumentsUpload
        uploads={uploads}
        {...docUploadProps}
        buttonRef={otherDocsFieldRef}
        trackingOrigin="other"
        maxFiles={2}
        isReduced
        trackNwtEvent={trackNwtEvent}
      />
    </section>
  );
};
